import {
  AvailabilityResponse,
  CreateOrderResponse,
  DataEnvelopeOfCreateOrderRequest,
  DynamicLeadPayload,
  SendLeadResponse,
} from '@monorepo-types/dc/sales';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type CheckInHouseAvailability = { postalCode: string; product: string; orderType: string };
/**
 * Checks post code service availability for a given product and order type.
 *
 * @returns AvailabilityResponse OK
 */
export function checkInHouseAvailability(
  { postalCode, product, orderType }: CheckInHouseAvailability,
  requestConfig: ApiRequestConfig = {},
): Promise<AvailabilityResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/sales/public/in-house/${postalCode}/${product}/${orderType}/availability`,
      errors: { 400: 'Bad Request', 500: 'Internal Server Error', 502: 'Bad Gateway' },
    },
    requestConfig,
  );
}

type SendHardwareLeads = { requestBody: DynamicLeadPayload };
/**
 * Sends hardware leads to EnecoInHouse.
 *
 * @returns SendLeadResponse Created
 */
export function sendHardwareLeads(
  { requestBody }: SendHardwareLeads,
  requestConfig: ApiRequestConfig = {},
): Promise<SendLeadResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/sales/public/in-house/leads`,
      body: requestBody,
      errors: { 422: 'Unprocessable Entity', 500: 'Internal Server Error', 502: 'Bad Gateway' },
    },
    requestConfig,
  );
}

type CreateOrder = { requestBody: DataEnvelopeOfCreateOrderRequest };
/**
 * Create order for ServiceGemak to EnecoInHouse.
 *
 * @returns CreateOrderResponse Created
 */
export function createOrder(
  { requestBody }: CreateOrder,
  requestConfig: ApiRequestConfig = {},
): Promise<CreateOrderResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/sales/public/in-house/orders`,
      body: requestBody,
      errors: { 400: 'Bad Request', 422: 'Unprocessable Entity', 500: 'Internal Server Error', 502: 'Bad Gateway' },
    },
    requestConfig,
  );
}
